const BASE = process.env.REACT_APP_ACTOR_API_URL || 'http://localhost:3001';

async function call(path, options = {}, token, userId) {
  const res = await fetch(`${BASE}/assets${path}`, {
    headers: {
      'Content-Type': 'application/json',
      ...(token  ? { Authorization: `Bearer ${token}` } : {}),
      ...(userId ? { 'x-user-id': userId } : {}),
    },
    ...options,
  });
  const json = await res.json();
  if (!json.success) throw new Error(json.message || 'Request failed');
  return json.data;
}

export const listAssets     = (token, userId)        => call('',        {}, token, userId);
export const createAsset    = (body, token, userId)  => call('',        { method: 'POST', body: JSON.stringify(body) }, token, userId);
export const bulkSaveAssets = (items, token, userId) => call('/bulk',   { method: 'POST', body: JSON.stringify(items) }, token, userId);
export const deleteAsset    = (id, token, userId)    => call(`/${id}`,  { method: 'DELETE' }, token, userId);
